{
  "canvas.a11y.skipToMain": "Skip to main content",
  "canvas.account.backToDashboard": "← Dashboard",
  "canvas.account.changesSaved": "Changes saved.",
  "canvas.account.currentPassword": "Current password",
  "canvas.account.emailAddress": "Email address",
  "canvas.account.fullName": "Full name",
  "canvas.account.fullNamePlaceholder": "Your name",
  "canvas.account.heading": "Account",
  "canvas.account.newPassword": "New password",
  "canvas.account.passwordFailed": "Failed to change password",
  "canvas.account.passwordSection": "Change password",
  "canvas.account.passwordUpdated": "Password updated.",
  "canvas.account.profileSection": "Profile",
  "canvas.account.saveChanges": "Save changes",
  "canvas.account.saveFailed": "Failed to save changes",
  "canvas.account.saving": "Saving…",
  "canvas.account.signOut": "Sign out",
  "canvas.account.signOutHint": "Sign out of your account on this device.",
  "canvas.account.signOutSection": "Sign out",
  "canvas.account.subtitle": "Manage your profile and account settings.",
  "canvas.account.updatePassword": "Update password",
  "canvas.account.updating": "Updating…",
  "canvas.addPagePicker.cancel": "Cancel",
  "canvas.addPagePicker.componentHint": "A reusable component key is derived from the name.",
  "canvas.addPagePicker.componentKey": "Component key: {key}",
  "canvas.addPagePicker.route": "Route: /{route}",
  "canvas.addPagePicker.routeHint": "Route is derived from the name (e.g. About → /about).",
  "canvas.answer.title": "Websites",
  "canvas.answer.empty": "No websites match.",
  "canvas.answer.failed": "Could not load the projects.",
  "canvas.answer.more": "{n} of {total} projects, newest first",
  "canvas.answer.action.preview": "Preview {name}",
  "canvas.answer.action.previewOf": "Preview {name} live",
  "canvas.answer.action.canvas": "Open the canvas of {name}",
  "canvas.answer.action.analytics": "Analytics of {name}",
  "canvas.status.title": "Website status",
  "canvas.status.none": "This workspace has no website yet.",
  "canvas.status.missing": "No website in this workspace matches.",
  "canvas.status.notWebsite": "{name} is not a website. This card shows websites.",
  "canvas.status.storeApp": "{name} is an app from the App Store, not a project of this workspace. This card shows websites.",
  "canvas.status.more": "{n} of {total} websites",
  "canvas.status.openSite": "{name}: environments and versions",
  "canvas.status.back": "All websites",
  "canvas.status.versions": "Recent versions",
  "canvas.status.live.checking": "Checking…",
  "canvas.status.live.live": "Live",
  "canvas.status.live.unavailable": "Not available",
  "canvas.status.live.unknown": "Could not check",
  "canvas.status.live.never": "Never published",
  "canvas.status.env.off": "Off",
  "canvas.status.env.published": "Published release",
  "canvas.status.env.version": "Version {value}",
  "canvas.status.env.branch": "Branch {value}",
  "canvas.status.env.latest": "Latest of {value}",
  "canvas.status.env.never": "Never published",
  "canvas.studioEdge.library.title": "Disconnect “{library}”?",
  "canvas.studioEdge.library.message": "“{project}” will stop using this library. The components it takes from “{library}” will stop resolving.",
  "canvas.studioEdge.library.confirm": "Disconnect",
  "canvas.studioEdge.integration.title": "Remove “{integration}” from “{project}”?",
  "canvas.studioEdge.integration.message": "The integration moves to organization scope and stops being specific to “{project}”.",
  "canvas.studioEdge.integration.confirm": "Remove",
  "canvas.boardMenu.new.aria": "New — create a project, library, integration and more",
  "canvas.boardMenu.new.label": "New",
  "canvas.boardPage.contextMenu.delete": "Delete",
  "canvas.boardPage.contextMenu.rename": "Rename",
  "canvas.boardPage.defaultName": "Page {n}",
  "canvas.boardPage.delete.title": "Delete page “{name}”?",
  "canvas.boardPage.delete.untitled": "Untitled",
  "canvas.boardPage.delete.messageEmpty": "The page will be deleted. This can’t be undone.",
  "canvas.boardPage.delete.messageOne": "The page and the 1 tile on it will be deleted. This can’t be undone.",
  "canvas.boardPage.delete.messageMany": "The page and the {count} tiles on it will be deleted. This can’t be undone.",
  "canvas.codeEditor.close": "Close code editor",
  "canvas.contextMenu.autoLayout": "Auto-layout",
  "canvas.contextMenu.delete": "Delete",
  "canvas.contextMenu.deletePage": "Delete page",
  "canvas.contextMenu.deleteComponent": "Delete component",
  "canvas.contextMenu.deleteVariation": "Delete variation",
  "canvas.contextMenu.duplicate": "Duplicate",
  "canvas.contextMenu.group": "Group",
  "canvas.contextMenu.new": "New",
  "canvas.contextMenu.newComponent": "Component",
  "canvas.contextMenu.newIntegration": "Integration",
  "canvas.contextMenu.newPage": "Page",
  "canvas.contextMenu.newSharedLibrary": "Shared library",
  "canvas.contextMenu.resetView": "Reset view",
  "canvas.contextMenu.selectAll": "Select all",
  "canvas.contextMenu.ungroup": "Ungroup",
  "canvas.contextMenu.versionHistory": "Version history",
  "canvas.dashboard.allWorkspaces": "All workspaces",
  "canvas.dashboard.deselect": "Deselect",
  "canvas.dashboard.help.clickCard": "Click a project card to open it.",
  "canvas.dashboard.help.rightClick": "Right-click the canvas for options.",
  "canvas.dashboard.kind.all": "Browse all",
  "canvas.dashboard.kind.integration": "Integrations",
  "canvas.dashboard.kind.library": "Libraries",
  "canvas.dashboard.kind.plugin": "Plugins",
  "canvas.dashboard.kind.registrar": "Domain Registrars",
  "canvas.dashboard.kind.template": "Templates",
  "canvas.dashboard.marketplace": "Marketplace",
  "canvas.dashboard.newOrganization": "New organization",
  "canvas.dashboard.noMembers": "No members yet",
  "canvas.dashboard.openWorkspace": "Open workspace →",
  "canvas.dashboard.rail.featuredTemplates": "Featured templates",
  "canvas.dashboard.rail.integrationsEmpty": "Add an integration available to your whole organization",
  "canvas.dashboard.rail.templatesEmpty": "Browse and pin templates for quick access",
  "canvas.dashboard.toggleWorkspaces": "Toggle workspaces",
  "canvas.dashboard.workspaceDefault": "default",
  "canvas.dashboard.workspaces": "Workspaces",
  "canvas.deleteProject.body": "This action cannot be undone. Type the project key below to confirm deletion.",
  "canvas.deleteProject.cancel": "Cancel",
  "canvas.deleteProject.confirm": "Delete project",
  "canvas.deleteProject.confirmLabel": "Type \"{key}\" to confirm:",
  "canvas.deleteProject.failed": "The project was not deleted. Try again.",
  "canvas.deleteProject.inputAria": "Confirm project key",
  "canvas.deleteProject.title": "Delete \"{name}\"?",
  "canvas.duplicateProject.body": "Pick a name and key for the copy.",
  "canvas.duplicateProject.cancel": "Cancel",
  "canvas.duplicateProject.error.failed": "Duplicate failed.",
  "canvas.duplicateProject.error.keyRequired": "Key is required.",
  "canvas.duplicateProject.error.unsupported": "Duplicate not supported by this SDK version.",
  "canvas.duplicateProject.fallbackName": "project",
  "canvas.duplicateProject.keyAria": "New project key",
  "canvas.duplicateProject.keyLabel": "New project key (slug)",
  "canvas.duplicateProject.nameLabel": "New project name",
  "canvas.duplicateProject.namePlaceholder": "Copy of {name}",
  "canvas.duplicateProject.submit": "Duplicate",
  "canvas.duplicateProject.submitBusy": "Duplicating…",
  "canvas.duplicateProject.title": "Duplicate \"{name}\"",
  "canvas.editMetadata.body": "Rename the project or change its key.",
  "canvas.editMetadata.cancel": "Cancel",
  "canvas.editMetadata.error.failed": "Save failed.",
  "canvas.editMetadata.error.required": "Name and key are required.",
  "canvas.editMetadata.error.unsupported": "Update not supported by this SDK version.",
  "canvas.editMetadata.keyAria": "Project key",
  "canvas.editMetadata.keyLabel": "Project key (slug)",
  "canvas.editMetadata.nameLabel": "Project name",
  "canvas.editMetadata.namePlaceholder": "My project",
  "canvas.editMetadata.save": "Save",
  "canvas.editMetadata.saveBusy": "Saving…",
  "canvas.editMetadata.title": "Edit project metadata",
  "canvas.entity.comments": "Comments",
  "canvas.entity.dataItem.hint": "Put a record, document, email or ticket on this board.",
  "canvas.entity.dataItem.label": "Data item",
  "canvas.entity.expand": "Expand",
  "canvas.entity.group.items": "Items",
  "canvas.entity.loadFailed": "This item could not be loaded.",
  "canvas.entity.makeVariation": "Make variation",
  "canvas.entity.picker.empty": "Nothing matched that search.",
  "canvas.entity.picker.placeholder": "Search records, documents, email…",
  "canvas.entity.picker.subtitle": "Search the workspace and place the result on this board.",
  "canvas.entity.picker.title": "Add data item",
  "canvas.entity.sample": "Sample",
  "canvas.entity.untitled": "Untitled",
  "canvas.entity.variation.bodyLabel": "Body",
  "canvas.entity.variation.deleteMessage": "The variation record is deleted for everyone in this workspace, together with its tile on every board page. This can’t be undone.",
  "canvas.entity.variation.deleteTitle": "Delete variation “{name}”?",
  "canvas.entity.variation.rationaleLabel": "Rationale",
  "canvas.entity.variation.title": "{title} (variation)",
  "canvas.entity.variation.titleLabel": "Title",
  "canvas.groupLabel.renameTitle": "Double-click to rename — saves on blur or Enter",
  "canvas.header.account": "Account",
  "canvas.header.marketplace": "Marketplace",
  "canvas.integrationPicker.cancel": "Cancel",
  "canvas.integrationPicker.error.noOrgId": "No org id for {slug}",
  "canvas.integrationPicker.error.pickProject": "Pick a project for project scope",
  "canvas.integrationPicker.field.displayName": "Display name",
  "canvas.integrationPicker.field.displayNamePlaceholder": "Human-readable label",
  "canvas.integrationPicker.field.secret": "Secret",
  "canvas.integrationPicker.field.slug": "Slug",
  "canvas.integrationPicker.field.slugHint": "Unique within scope.",
  "canvas.integrationPicker.field.slugPlaceholder": "default",
  "canvas.integrationPicker.scope": "Scope",
  "canvas.integrationPicker.scopeOrg": "Org",
  "canvas.integrationPicker.scopeProject": "Project",
  "canvas.integrationPicker.scopeWorkspace": "Workspace",
  "canvas.integrationPicker.searchPlaceholder": "Search integrations…",
  "canvas.lab.welcome.body": "Start by creating a new app — or pin an existing project from your dashboard. You can also install integrations, MCP connectors, libraries, and plugins as draggable tiles.",
  "canvas.lab.welcome.cta": "+ Create your new app",
  "canvas.lab.welcome.secondary": "or install an integration",
  "canvas.lab.welcome.title": "Welcome to your lab",
  "canvas.lazyPage.loadFailed": "Couldn’t load this page. Refresh to try again.",
  "canvas.libraryPicker.empty": "No libraries found.",
  "canvas.libraryPicker.searchPlaceholder": "Search libraries…",
  "canvas.libraryPicker.subtitle": "Search public libraries or projects in your orgs.",
  "canvas.libraryPicker.title": "Import library",
  "canvas.marketplace.installIncompleteMessage": "The \"{name}\" tile was placed on the canvas, but the install dispatch did not complete ({error}). Reopen the marketplace card to retry.",
  "canvas.marketplace.installIncompleteTitle": "Marketplace install incomplete",
  "canvas.marketplace.unknownError": "unknown error",
  "canvas.mcp.cancel": "Cancel",
  "canvas.mcp.connect": "Connect",
  "canvas.mcp.connected": "Connected {name}",
  "canvas.mcp.connecting": "Connecting…",
  "canvas.mcp.error.connectFailedTitle": "Connect failed",
  "canvas.mcp.error.unknown": "Unknown error",
  "canvas.mcp.error.urlRequiredMessage": "Enter the MCP server URL.",
  "canvas.mcp.error.urlRequiredTitle": "URL required",
  "canvas.mcp.field.auth": "Authentication",
  "canvas.mcp.field.name": "Name",
  "canvas.mcp.field.namePlaceholder": "e.g. Symbols MCP",
  "canvas.mcp.field.transport": "Transport",
  "canvas.mcp.field.url": "Server URL",
  "canvas.mcp.subtitle": "Connect an MCP server (tools, resources).",
  "canvas.mcp.suggest.label": "Connect Symbols MCP",
  "canvas.mcp.suggest.title": "Connect Symbols MCP — pre-fills URL and name",
  "canvas.mcp.title": "New MCP connector",
  "canvas.mcpChip.title": "MCP connector: {name}",
  "canvas.mcpChip.disabled": "Disabled",
  "canvas.mcpChip.live": "Live",
  "canvas.minimizedDock.close": "Close",
  "canvas.minimizedDock.closeAria": "Close minimized app",
  "canvas.mode.inspect": "Inspect",
  "canvas.mode.interact": "Interact",
  "canvas.mode.move": "Move",
  "canvas.mode.pan": "Pan",
  "canvas.navbar.actions.aria": "Canvas actions menu",
  "canvas.navbar.actions.title": "Canvas actions",
  "canvas.navbar.env.devAria": "Development environment",
  "canvas.navbar.env.devTitle": "Switch to development environment",
  "canvas.navbar.env.eyebrow": "ENV",
  "canvas.navbar.env.prodAria": "Production environment",
  "canvas.navbar.env.prodTitle": "Switch to production environment",
  "canvas.navbar.env.stagingAria": "Staging environment",
  "canvas.navbar.env.stagingTitle": "Switch to staging environment",
  "canvas.navbar.members.aria": "Project members",
  "canvas.navbar.members.empty": "No members loaded.",
  "canvas.navbar.members.invite": "+ Invite",
  "canvas.navbar.members.panelTitle": "Members",
  "canvas.navbar.members.title": "Members",
  "canvas.navbar.mode.default": "Default mode",
  "canvas.navbar.mode.eyebrow": "MODE",
  "canvas.navbar.mode.inspect": "Inspect mode",
  "canvas.navbar.mode.pan": "Pan mode",
  "canvas.navbar.pages.close": "Close",
  "canvas.navbar.pages.default": "Default",
  "canvas.navbar.pages.eyebrow": "PAGE",
  "canvas.navbar.pages.panelTitle": "Pages",
  "canvas.navbar.pages.title": "Switch canvas page",
  "canvas.navbar.redo": "Redo  ⌘⇧Z",
  "canvas.navbar.search": "Search  ⌘K",
  "canvas.navbar.share.copied": "Copied!",
  "canvas.navbar.share.copy": "Copy",
  "canvas.navbar.share.copyFailedMessage": "Please copy the URL manually.",
  "canvas.navbar.share.copyFailedTitle": "Copy failed",
  "canvas.navbar.share.panelTitle": "Share",
  "canvas.navbar.share.title": "Share project",
  "canvas.navbar.undo": "Undo  ⌘Z",
  "canvas.navbar.versionHistory": "Version history",
  "canvas.newProject.cancel": "Cancel",
  "canvas.newProject.error.nameRequired": "Please enter a project name.",
  "canvas.newProject.error.noOrg": "Could not resolve org for this workspace.",
  "canvas.newProject.error.noSdk": "SDK not available.",
  "canvas.newProject.error.pickSource": "Select a project to scaffold from.",
  "canvas.newProject.nameLabel": "Project name",
  "canvas.newProject.namePlaceholder": "My project…",
  "canvas.newProject.subtitle": "Pick a template and name your project. You publish it to the web.",
  "canvas.newProject.templateApp.hint": "Web app scaffold — dashboard, settings, auth",
  "canvas.newProject.templateApp.label": "Desktop & Web app",
  "canvas.newProject.templateBlank.hint": "A simple Hello world component",
  "canvas.newProject.templateBlank.label": "Blank",
  "canvas.newProject.templateDeck.hint": "Slide deck sourced from commercials/deck",
  "canvas.newProject.templateDeck.label": "Presentation",
  "canvas.newProject.templateLibrary.hint": "Shared component library for your workspace",
  "canvas.newProject.templateLibrary.label": "Library",
  "canvas.newProject.templateMobile.hint": "Native mobile app scaffold — home, settings",
  "canvas.newProject.templateMobile.label": "Mobile App",
  "canvas.newProject.templateService.hint": "Backend service scaffold — API endpoints + health",
  "canvas.newProject.templateService.label": "Service",
  "canvas.newProject.title": "New project",
  "canvas.notFound.backToDashboard": "Back to dashboard",
  "canvas.notFound.retry": "Retry",
  "canvas.notFound.signIn": "Sign in",
  "canvas.page.account.title": "Account / Symbols.app",
  "canvas.page.agents.title": "Agents",
  "canvas.page.dashboard.title": "Dashboard / Symbols.app",
  "canvas.page.marketplace.title": "Marketplace / Symbols.app",
  "canvas.page.myAgents.title": "My agents",
  "canvas.page.notFound.title": "Not found / Symbols.app",
  "canvas.page.resetPassword.title": "Reset password / Symbols.app",
  "canvas.page.sessionBridge.title": "Session bridge · Symbols",
  "canvas.page.signin.title": "Sign in / Symbols.app",
  "canvas.page.signup.title": "Sign up / Symbols.app",
  "canvas.page.signupConfirmation.title": "Confirm email / Symbols.app",
  "canvas.page.teamAndAgents.title": "Team & agents",
  "canvas.page.waitlist.title": "Waitlist / Symbols.app",
  "canvas.page.workspaces.fallbackName": "Workspace",
  "canvas.page.workspaces.fallbackTitle": "Workspaces / Symbols.app",
  "canvas.page.workspaces.title": "{name} · Workspaces / Symbols.app",
  "canvas.pageSlot.addToWorkspace": "Add to Workspace",
  "canvas.pageSlot.apps": "Apps",
  "canvas.pageSlot.appsSidebar": "Apps sidebar",
  "canvas.pageSlot.appsSidebarAria": "Toggle apps sidebar",
  "canvas.pageSlot.back": "Back",
  "canvas.pageSlot.close": "Close",
  "canvas.pageSlot.forward": "Forward",
  "canvas.pageSlot.keepPane": "Keep this pane open",
  "canvas.pageSlot.minimize": "Minimize",
  "canvas.pageSlot.newPane": "New pane",
  "canvas.pageSlot.openAsFullPage": "Open as full page",
  "canvas.pageSlot.placeholder.heading": "Choose an app for this pane",
  "canvas.pageSlot.placeholder.hint": "Pick any app from the launcher to open it here, beside the current one.",
  "canvas.pageSlot.saveAsApp": "Save as app",
  "canvas.pageSlot.sidebarHide": "Hide sidebar",
  "canvas.pageSlot.sidebarShow": "Show sidebar",
  "canvas.pageSlot.toggleFullscreen": "Toggle fullscreen",
  "canvas.pageSlot.resizeWindow": "Resize window",
  "canvas.pageSlot.fullscreenEnter": "Full screen",
  "canvas.pageSlot.fullscreenExit": "Exit full screen",
  "canvas.projectMenu.aria": "Project options",
  "canvas.projectMenu.copyUrl.label": "Copy URL",
  "canvas.projectMenu.delete.label": "Delete project",
  "canvas.projectMenu.directDev.label": "Direct (dev)",
  "canvas.projectMenu.directDev.title": "Opens the dev subdomain URL",
  "canvas.projectMenu.directProd.label": "Direct (prod)",
  "canvas.projectMenu.directProd.title": "Opens the production subdomain URL",
  "canvas.projectMenu.duplicate.label": "Duplicate…",
  "canvas.projectMenu.editMetadata.label": "Edit metadata…",
  "canvas.projectMenu.importLibrary.aria": "Import Library — link a shared component library",
  "canvas.projectMenu.importLibrary.label": "Import Library…",
  "canvas.projectMenu.importLibrary.title": "Link a shared library to this project",
  "canvas.projectMenu.openInApp.label": "Open in App",
  "canvas.projectMenu.openInAppEnv.label": "Open in App (env)",
  "canvas.projectMenu.openInAppEnv.title": "Open in the canvas editor pinned to this environment",
  "canvas.projectMenu.openPreview.label": "Open Preview",
  "canvas.projectMenu.openPreview.title": "Opens the preview URL for this project",
  "canvas.projectMenu.publish.label": "Publish",
  "canvas.projectMenu.refetchScreenshot.aria": "Refetch screenshot — recapture this project and reload the tile",
  "canvas.projectMenu.refetchScreenshot.label": "Refetch screenshot",
  "canvas.projectMenu.refetchScreenshot.title": "Recapture on the server, then reload the tile in place",
  "canvas.projectMenu.section.danger": "Danger",
  "canvas.projectMenu.section.integrations": "Integrations",
  "canvas.projectMenu.section.manage": "Manage",
  "canvas.projectMenu.section.open": "Open",
  "canvas.projectMenu.settings.label": "Settings…",
  "canvas.projectMenu.versionHistory.label": "Version history",
  "canvas.projectNavbar.addComponent.hint": "Create a new reusable component.",
  "canvas.projectNavbar.addComponent.label": "Component",
  "canvas.projectNavbar.addIntegration.hint": "Connect a service (Supabase, GitHub, …).",
  "canvas.projectNavbar.addIntegration.label": "Integration",
  "canvas.projectNavbar.addPage.hint": "Create a new page in this project.",
  "canvas.projectNavbar.addPage.label": "Page",
  "canvas.projectNavbar.addSharedLibrary.hint": "Import an existing project as a shared library.",
  "canvas.projectNavbar.addSharedLibrary.label": "Shared library",
  "canvas.projectNavbar.createAria": "Add to this project",
  "canvas.projectNavbar.createTitle": "Create",
  "canvas.projectNavbar.menuAria": "Add to this project…",
  "canvas.projectTile.moreOptions": "More options",
  "canvas.projectTile.updated": "Edited {time}",
  "canvas.prompt.aria": "AI assistant",
  "canvas.prompt.attach.aria": "Add content",
  "canvas.prompt.attach.armedTitle": "Build mode armed — open the menu to disarm",
  "canvas.prompt.attach.buildApp": "Build app",
  "canvas.prompt.attach.buildAppArmed": "Armed — sends build instead of answering",
  "canvas.prompt.attach.buildAppHint": "Sends build or improve an app",
  "canvas.prompt.attach.event": "Event",
  "canvas.prompt.attach.heading": "Add content",
  "canvas.prompt.attach.member": "Member",
  "canvas.prompt.attach.note": "Note or doc",
  "canvas.prompt.attach.photoOrFile": "Photo or file",
  "canvas.prompt.attach.section": "Add section",
  "canvas.prompt.attach.ticket": "Ticket",
  "canvas.prompt.bridgeDown": "Run `smbls claude` in your project to build live.",
  "canvas.prompt.collapseComposer": "Collapse composer",
  "canvas.prompt.expandBar": "Expand prompt bar",
  "canvas.prompt.expandComposer": "Expand composer",
  "canvas.prompt.inspect": "Inspect mode",
  "canvas.prompt.mention.channel": "Channels",
  "canvas.prompt.mention.event": "Events",
  "canvas.prompt.mention.person": "People",
  "canvas.prompt.mention.reference": "Notes & docs",
  "canvas.prompt.mention.ticket": "Tickets",
  "canvas.prompt.mentionSuggestions": "Mention suggestions",
  "canvas.prompt.minimizeBar": "Minimize prompt bar",
  "canvas.prompt.openInSidebar": "Open in sidebar",
  "canvas.prompt.reasoningAria": "Assistant reasoning",
  "canvas.prompt.send": "Send prompt",
  "canvas.prompt.thinking": "Thinking…",
  "canvas.prompt.uploadImage": "Upload image",
  "canvas.prompt.voice": "Talk to the assistant — hold for a one-shot command",
  "canvas.publish.changesTitle": "Changes to release",
  "canvas.publish.checking": "Checking for changes…",
  "canvas.publish.noChanges": "No new changes to release.",
  "canvas.publish.subtitle": "Release your latest changes to a live environment.",
  "canvas.publish.title": "Publish project",
  "canvas.publish.toStaging": "Publish to Staging",
  "canvas.publish.toProduction": "Publish to Production",
  "canvas.publish.publishing": "Publishing…",
  "canvas.publish.unavailable": "Publishing is not available here.",
  "canvas.publish.failed": "Publish failed.",
  "canvas.publish.confirm.title": "Publish “{name}” to Production?",
  "canvas.publish.confirm.titlePlain": "Publish to Production?",
  "canvas.publish.confirm.message": "Your latest changes go live on the production site, for every visitor.",
  "canvas.publish.confirm.button": "Publish",
  "canvas.record.page.deleteTitle": "Delete page “{name}” from the project?",
  "canvas.record.page.deleteMessage": "The page is deleted for everyone, together with its tile on every board page. Earlier versions in Version history still include it.",
  "canvas.record.component.deleteTitle": "Delete component “{name}” from the project?",
  "canvas.record.component.deleteMessage": "The component is deleted for everyone, together with its tile on every board page. Pages that use it no longer show it. Earlier versions in Version history still include it.",
  "canvas.record.deleteFailed": "Could not delete “{name}”.",
  "canvas.remoteUpdate.dismiss": "Dismiss",
  "canvas.remoteUpdate.message": "This project was updated — reload to see the latest.",
  "canvas.remoteUpdate.reload": "Reload",
  "canvas.repoPicker.add": "Add to canvas",
  "canvas.repoPicker.error.invalidInput": "Enter owner/repo — e.g. symbo-ls/example",
  "canvas.repoPicker.error.listFailed": "Could not list org repos",
  "canvas.repoPicker.error.noOrg": "No active organization to list repos from",
  "canvas.repoPicker.error.notFound": "Repository not found",
  "canvas.repoPicker.find": "Find",
  "canvas.repoPicker.inputPlaceholder": "owner/repo  ·  e.g. symbo-ls/example",
  "canvas.repoPicker.orgEmpty": "No repos from the connected org (the GitHub App may not be installed yet). Use the Public tab to add any repo.",
  "canvas.repoPicker.tab.org": "My org",
  "canvas.repoPicker.tab.public": "Public repo",
  "canvas.repoPicker.title": "Add a GitHub repository",
  "canvas.repoTile.fallbackName": "repository",
  "canvas.repoTile.private": "Private",
  "canvas.repoTile.removeAria": "Remove {name} from board",
  "canvas.repoTile.removeTitle": "Remove from board",
  "canvas.scopeRail.addMcpConnector": "+ Add MCP connector",
  "canvas.scopeRail.addWorkspaceIntegration": "+ Add workspace integration",
  "canvas.scopeRail.org": "Org integrations",
  "canvas.scopeRail.orgEmpty": "No org-wide integrations installed.",
  "canvas.scopeRail.workspace": "Workspace",
  "canvas.sessionBridge.body": "Session bridge. Hands off the canvas session to other Symbols subdomains.",
  "canvas.settings.autoLayout.confirmButton": "Rearrange",
  "canvas.settings.autoLayout.confirmMessage": "Every card on the board moves into a grid. Positions placed by hand change for everyone in this workspace. This can’t be undone.",
  "canvas.settings.autoLayout.confirmTitle": "Rearrange all cards?",
  "canvas.settings.autoLayout.hint": "Rearranges all cards into a tidy grid and persists positions.",
  "canvas.settings.autoLayout.label": "Auto layout",
  "canvas.settings.autoLayout.run": "Run now",
  "canvas.settings.cardPlacement.freeform": "Freeform",
  "canvas.settings.cardPlacement.hint": "Freeform lets you drag cards out of columns and place them anywhere on the canvas.",
  "canvas.settings.cardPlacement.inColumns": "In columns",
  "canvas.settings.cardPlacement.label": "Card placement",
  "canvas.settings.cardsPerRow.hint": "How many cards sit side-by-side in every board column.",
  "canvas.settings.cardsPerRow.label": "Cards per row",
  "canvas.settings.dragMode.free": "Free",
  "canvas.settings.dragMode.grid": "Grid",
  "canvas.settings.dragMode.hint": "Free lets you drop cards anywhere; Grid snaps to 24px increments.",
  "canvas.settings.dragMode.label": "Drag mode",
  "canvas.settings.excludedCols.hint": "Tickets in selected columns will not be included in the sidebar totals.",
  "canvas.settings.excludedCols.label": "Exclude from counts",
  "canvas.settings.hiddenCols.empty": "No hidden columns.",
  "canvas.settings.hiddenCols.hint": "Columns hidden via the column \"⋯\" menu; bring them back here.",
  "canvas.settings.hiddenCols.label": "Hidden columns",
  "canvas.settings.hiddenCols.show": "Show",
  "canvas.settings.projectScopeNote": "These apply to the project canvas — open a project to change them.",
  "canvas.settings.showComponents.hint": "Seed the project’s component frames onto the board. Off by default.",
  "canvas.settings.showComponents.label": "Show components",
  "canvas.settings.showDesignSystem.hint": "Seed the design-system frames onto the board. Off by default.",
  "canvas.settings.showDesignSystem.label": "Show design system",
  "canvas.settings.showMinimap.hint": "Miniature overview at the bottom-right of the canvas.",
  "canvas.settings.showMinimap.label": "Show minimap",
  "canvas.settings.showRulers.hint": "Screen-space rulers along the top and left edges.",
  "canvas.settings.showRulers.label": "Show rulers",
  "canvas.settings.snap.hint": "Master toggle for all snapping behaviours.",
  "canvas.settings.snap.label": "Snap",
  "canvas.settings.snapGrid.hint": "Pins drags to the canvas grid step.",
  "canvas.settings.snapGrid.label": "Snap to grid",
  "canvas.settings.snapGuides.hint": "Snaps drags onto user-placed rulers and guides.",
  "canvas.settings.snapGuides.label": "Snap to guides",
  "canvas.settings.snapItems.hint": "Pulls drags to other cards as they align.",
  "canvas.settings.snapItems.label": "Snap to items",
  "canvas.settings.subtitle": "Workspace and project canvas preferences.",
  "canvas.settings.switchTitle": "Applies to the open project canvas",
  "canvas.settings.tabProject.hint": "Canvas viewport, snap, grid and selection tools.",
  "canvas.settings.tabProject.label": "Project",
  "canvas.settings.tabTasks.hint": "Board columns, cards and layout.",
  "canvas.settings.tabTasks.label": "Tasks",
  "canvas.settings.tabWorkspace.hint": "Workspace-wide drag, layout and picker settings.",
  "canvas.settings.tabWorkspace.label": "Workspace",
  "canvas.settings.title": "Settings",
  "canvas.shortcuts.autoLayout": "Auto-layout",
  "canvas.shortcuts.clearClose": "Clear / close",
  "canvas.shortcuts.close": "Close",
  "canvas.shortcuts.delete": "Delete",
  "canvas.shortcuts.duplicate": "Duplicate",
  "canvas.shortcuts.fitSelection": "Fit selection",
  "canvas.shortcuts.group": "Group",
  "canvas.shortcuts.inspectTool": "Inspect tool",
  "canvas.shortcuts.interactTool": "Interact tool",
  "canvas.shortcuts.moveTool": "Move tool",
  "canvas.shortcuts.nudge1": "Nudge 1px",
  "canvas.shortcuts.nudge10": "Nudge 10px",
  "canvas.shortcuts.pan": "Pan",
  "canvas.shortcuts.panTool": "Pan tool",
  "canvas.shortcuts.redo": "Redo",
  "canvas.shortcuts.resetView": "Reset view",
  "canvas.shortcuts.selectAll": "Select all",
  "canvas.shortcuts.settings": "Settings",
  "canvas.shortcuts.temporaryPan": "Temporary pan",
  "canvas.shortcuts.thisDialog": "This dialog",
  "canvas.shortcuts.title": "Keyboard shortcuts",
  "canvas.shortcuts.undo": "Undo",
  "canvas.shortcuts.ungroup": "Ungroup",
  "canvas.shortcuts.zoomAroundCursor": "Zoom around cursor",
  "canvas.sidebar.action.preview": "Preview",
  "canvas.sidebar.action.projectSettings": "Project settings",
  "canvas.sidebar.action.publish": "Publish",
  "canvas.sidebar.action.versionHistory": "Version history",
  "canvas.sidebar.env.current": "current",
  "canvas.sidebar.env.development": "Development",
  "canvas.sidebar.env.group": "Environment",
  "canvas.sidebar.env.production": "Production",
  "canvas.sidebar.env.staging": "Staging",
  "canvas.sidebar.env.switchTo": "switch to",
  "canvas.sidebar.filter.all": "Everything",
  "canvas.sidebar.filter.components": "Components",
  "canvas.sidebar.filter.designSystem": "Design system",
  "canvas.sidebar.filter.pages": "Pages",
  "canvas.sidebar.group.environment": "ENVIRONMENT",
  "canvas.sidebar.group.filter": "FILTER",
  "canvas.sidebar.group.pages": "PAGES",
  "canvas.sidebar.group.project": "PROJECT",
  "canvas.sidebar.pages.add": "Add page",
  "canvas.sidebar.sections": "SECTIONS",
  "canvas.slot.openApp": "Open {name}",
  "canvas.slot.openAppGeneric": "Open app",
  "canvas.splitView.close": "Close split view",
  "canvas.splitView.open": "Open split view",
  "canvas.studioNavbar.createAria": "Create project or library",
  "canvas.studioSidebar.analytics": "Analytics",
  "canvas.studioSidebar.configure": "Configure",
  "canvas.studioSidebar.copyUrl": "Copy URL",
  "canvas.studioSidebar.details": "Details",
  "canvas.studioSidebar.env.development": "Development",
  "canvas.studioSidebar.env.production": "Production",
  "canvas.studioSidebar.env.staging": "Staging",
  "canvas.studioSidebar.envAria": "Open directly — choose environment",
  "canvas.studioSidebar.envTitle": "Choose environment",
  "canvas.studioSidebar.open": "Open",
  "canvas.studioSidebar.openCanvas": "Open canvas",
  "canvas.studioSidebar.openDirectly": "Open directly",
  "canvas.studioSidebar.openGithub": "Open GitHub",
  "canvas.studioSidebar.openNpm": "Open npm",
  "canvas.studioSidebar.openOnGithub": "Open on GitHub",
  "canvas.studioSidebar.openService": "Open service",
  "canvas.studioSidebar.preview": "Preview",
  "canvas.surface.empty.heading": "Nothing to render here yet",
  "canvas.surface.empty.hint": "This project has no pages yet. Add one from the \"+ New\" menu, or publish content via the CLI.",
  "canvas.team.agent.fallback": "Agent",
  "canvas.team.agentAccess.adminHint": "Full control — content plus team + assignment management.",
  "canvas.team.agentAccess.adminLabel": "Admin",
  "canvas.team.agentAccess.editorHint": "Views and creates content — tickets, docs, messages.",
  "canvas.team.agentAccess.editorLabel": "Editor",
  "canvas.team.agentAccess.guestHint": "Read-only — views workspace content, never writes.",
  "canvas.team.agentAccess.guestLabel": "Guest",
  "canvas.team.agentCaption.brain": "Operational orchestrator",
  "canvas.team.agentCaption.custom": "Agent · {name}",
  "canvas.team.agentCaption.epicCompany": "Epic agent · company",
  "canvas.team.agentCaption.epicDesign": "Epic agent · design system",
  "canvas.team.agentCaption.epicDompiler": "Epic agent · dompiler",
  "canvas.team.agentCaption.epicExtensions": "Epic agent · extensions",
  "canvas.team.agentCaption.epicPapuna": "Epic agent · papuna",
  "canvas.team.agentCaption.epicSdk": "Epic agent · @symbo.ls/sdk",
  "canvas.team.agentCaption.epicServer": "Epic agent · server",
  "canvas.team.agentCaption.epicSmbls": "Epic agent · smbls core",
  "canvas.team.agentCaption.epicSymbolize": "Epic agent · symbolize",
  "canvas.team.agentCaption.helper": "Cross-epic helper",
  "canvas.team.agentCaption.infra": "Infrastructure",
  "canvas.team.agentCaption.observer": "Analytics / observer",
  "canvas.team.agentCaption.platform": "Platform · global",
  "canvas.team.platformNote": "Symbols' built-in assistants, available to every workspace.",
  "canvas.team.agentCaption.router": "PM / router",
  "canvas.team.agentCaption.studio": "Apps",
  "canvas.team.agentModal.accessLabel": "Access level",
  "canvas.team.agentModal.addEmpty": "Everyone is already assigned.",
  "canvas.team.agentModal.addLabel": "Assign to a person",
  "canvas.team.agentModal.assignedEmpty": "Not assigned to anyone yet.",
  "canvas.team.agentModal.assignedLabel": "Assigned to",
  "canvas.team.agentModal.errorBuiltIn": "This is a built-in agent — provision it before saving changes.",
  "canvas.team.agentModal.errorSaveFailed": "Failed to save agent",
  "canvas.team.agentModal.instructionsLabel": "System instructions",
  "canvas.team.agentModal.instructionsPlaceholder": "Describe how this agent should behave — its goals, tone, and boundaries…",
  "canvas.team.agentModal.permsLabel": "Granted permissions",
  "canvas.team.agentModal.restrictDescOff": "This agent can use every tool. Turn on to limit it to a selection.",
  "canvas.team.agentModal.restrictDescOn": "This agent can use only the capabilities enabled below.",
  "canvas.team.agentModal.restrictTitle": "Restrict to selected tools",
  "canvas.team.agentModal.saveChanges": "Save changes",
  "canvas.team.agentModal.saved": "Saved ✓",
  "canvas.team.agentModal.saving": "Saving…",
  "canvas.team.agentModal.toggleOff": "Off",
  "canvas.team.agentModal.toggleOn": "On",
  "canvas.team.agentModal.toolsIntroOff": "Pre-select capabilities here, then turn on “Restrict” above to enforce them.",
  "canvas.team.agentModal.toolsIntroOn": "Enabled capabilities — each unlocks the tools listed. The agent is capped to these.",
  "canvas.team.agentModal.toolsList": "Tools: {tools}",
  "canvas.team.assignee.fallback": "Member",
  "canvas.team.assignee.remove": "Remove",
  "canvas.team.contextMenu.connect": "Connect…",
  "canvas.team.contextMenu.copyEmail": "Copy email",
  "canvas.team.contextMenu.openProfile": "Open profile",
  "canvas.team.create.activateHint": "Provision the seed roster as real agents.",
  "canvas.team.create.activateLabel": "Activate agents",
  "canvas.team.create.addTitle": "Add",
  "canvas.team.create.agentHint": "Create an AI agent.",
  "canvas.team.create.agentLabel": "Agent",
  "canvas.team.create.aria": "Add human or agent",
  "canvas.team.create.humanHint": "Invite a teammate by email.",
  "canvas.team.create.humanLabel": "Human",
  "canvas.team.create.menuAria": "Add new…",
  "canvas.team.create.runChainHint": "Run the connected agents as a chain.",
  "canvas.team.create.runChainLabel": "Run chain",
  "canvas.team.filter.assignAll": "All",
  "canvas.team.filter.assignAssigned": "Assigned",
  "canvas.team.filter.assignUnassigned": "Unassigned",
  "canvas.team.filter.statusActive": "Active",
  "canvas.team.filter.statusAll": "All",
  "canvas.team.filter.statusIdle": "Idle",
  "canvas.team.filter.titleAssignment": "Assignment",
  "canvas.team.filter.titleStatus": "Status",
  "canvas.team.filter.titleType": "Type",
  "canvas.team.filter.typeAll": "All",
  "canvas.team.group.renameTitle": "Double-click to rename — commits on blur or Enter",
  "canvas.team.help.click": "Click a card to view details.",
  "canvas.team.help.drag": "Drag cards to rearrange.",
  "canvas.team.leave.title": "Remove “{name}” from “{team}”?",
  "canvas.team.leave.message": "“{name}” will no longer be a member of “{team}”. This changes the team itself, not only the board layout.",
  "canvas.team.leave.confirm": "Remove",
  "canvas.team.linkHandle.title": "Drag to connect",
  "canvas.team.member.email": "Email: {value}",
  "canvas.team.member.location": "Location: {value}",
  "canvas.team.member.timezone": "Timezone: {value}",
  "canvas.team.node.agentFallback": "agent",
  "canvas.team.node.openAria": "Open {name}",
  "canvas.team.node.personFallback": "person",
  "canvas.team.rail.agents": "AGENTS",
  "canvas.team.scope.all": "All agents",
  "canvas.team.scope.mine": "My agents",
  "canvas.team.toast.activatedMany": "Activated {count} agents",
  "canvas.team.toast.activatedOne": "Activated {count} agent",
  "canvas.team.toast.activationFailed": "Activation failed",
  "canvas.team.toast.allActive": "All agents already active",
  "canvas.team.toast.assignFailed": "Assignment failed",
  "canvas.team.toast.assigned": "Assigned {agent} → {person}",
  "canvas.team.toast.assignmentRemoved": "Assignment removed",
  "canvas.team.toast.chainCycle": "That link has a cycle — chains must be linear.",
  "canvas.team.toast.chainFailed": "Could not start the chain.",
  "canvas.team.toast.chainNeedsTwo": "Connect two or more agents (draw a link), then Run chain.",
  "canvas.team.toast.chainRunning": "Running chain: {names}",
  "canvas.team.toast.leaveFailed": "Could not remove “{name}” from “{team}”.",
  "canvas.team.toast.memberFallback": "member",
  "canvas.team.toast.removeFailed": "Failed to remove",
  "canvas.team.unassign.title": "Unassign “{agent}” from “{person}”?",
  "canvas.team.unassign.message": "“{person}” will no longer have “{agent}” among their agents. You can assign it again later.",
  "canvas.team.unassign.confirm": "Unassign",
  "canvas.tileFrame.desktopApp": "Desktop app",
  "canvas.tileFrame.firstSlide": "First slide",
  "canvas.tileFrame.library": "LIBRARY",
  "canvas.tileFrame.platform": "Platform",
  "canvas.tileFrame.platformProject": "Platform project",
  "canvas.tileFrame.tapToDesign": "Tap to design",
  "canvas.tileFrame.tvApp": "TV app",
  "canvas.tileFrame.webApp": "Web app",
  "canvas.tutorial.codeExplained.descr": "Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.",
  "canvas.tutorial.codeExplained.title": "HTML, CSS, and JavaScript unified!",
  "canvas.typeFilter.all": "All types",
  "canvas.typeFilter.app": "Web apps",
  "canvas.typeFilter.desktop": "Desktop",
  "canvas.typeFilter.library": "Libraries",
  "canvas.typeFilter.mobile": "Mobile",
  "canvas.typeFilter.platform": "Platform",
  "canvas.typeFilter.presentation": "Presentations",
  "canvas.typeFilter.tv": "TV",
  "canvas.typeFilter.website": "Websites",
  "canvas.versions.closeDetails": "Close version details",
  "canvas.versions.closeHistory": "Close version history",
  "canvas.versions.computingDiff": "Computing diff…",
  "canvas.versions.diff.close": "Close",
  "canvas.versions.diff.empty": "No content differences between these versions.",
  "canvas.versions.diff.subtitle": "Key-level changes per content namespace — added, removed and modified entries between the two versions.",
  "canvas.versions.empty": "No versions yet. Every push and publish creates one.",
  "canvas.versions.label.autosave": "Autosave",
  "canvas.versions.label.helloWorld": "Hello world",
  "canvas.versions.label.published": "Published release",
  "canvas.versions.latest": "Latest",
  "canvas.versions.loadingChanges": "Loading changes…",
  "canvas.versions.loadingVersions": "Loading versions…",
  "canvas.versions.openDiff": "Open diff",
  "canvas.versions.panelTitle": "Version history",
  "canvas.versions.previewThis": "Preview this version",
  "canvas.versions.published": "Published",
  "canvas.versions.restore.body": "The project will be rolled forward to this version’s state. A new version is created — nothing in the history is lost.",
  "canvas.versions.restore.cancel": "Cancel",
  "canvas.versions.restore.busy": "Restoring…",
  "canvas.versions.restore.title": "Restore version {version}?",
  "canvas.versions.restore.titlePlain": "Restore this version?",
  "canvas.versions.restoreThis": "Restore this version",
  "canvas.versions.snapshot": "Snapshot",
  "canvas.voice.addedPage": "Added a page",
  "canvas.voice.addedPageNamed": "Added page \"{name}\"",
  "canvas.voice.alreadyMode": "Already {mode}",
  "canvas.voice.canvasSettings": "Canvas settings",
  "canvas.voice.components": "Components",
  "canvas.voice.darkMode": "Dark mode",
  "canvas.voice.deleted": "Deleted",
  "canvas.voice.designSystem": "Design system",
  "canvas.voice.duplicated": "Duplicated",
  "canvas.voice.fitToView": "Fit to view",
  "canvas.voice.lightMode": "Light mode",
  "canvas.voice.noPageCalled": "No page called \"{name}\"",
  "canvas.voice.opened": "Opened \"{name}\"",
  "canvas.voice.redone": "Redone",
  "canvas.voice.selectionCleared": "Selection cleared",
  "canvas.voice.shortcuts": "Shortcuts",
  "canvas.voice.sidebars": "Sidebars",
  "canvas.voice.undone": "Undone",
  "canvas.voice.viewReset": "View reset",
  "canvas.voice.zoomedIn": "Zoomed in",
  "canvas.voice.zoomedOut": "Zoomed out",
  "canvas.tile.reloadLoop": "This page reloads itself in a loop, so the board stopped it.",
  "canvas.newProject.templateWebsite.label": "Website",
  "canvas.newProject.templateWebsite.hint": "Home, about and contact pages, ready to publish",
  "canvas.newProject.toWorkspaceApps": "Building a tool for your team? Create a workspace app",
  "canvas.workspaceAppGuard.title": "This is a workspace app",
  "canvas.workspaceAppGuard.body": "Workspace apps run inside a workspace. You build and change them in Workspace apps, not in the website editor.",
  "canvas.workspaceAppGuard.open": "Open Workspace apps",
  "canvas.workspaceAppGuard.edit": "Edit the app",
  "canvas.newProject.create": "Create project",
  "canvas.newProject.creating": "Creating…",
  "canvas.pageSlot.resizeSplit": "Resize split panes",
  "canvas.pageSlot.resizeSplitHint": "Drag to resize · Double-click or Enter to balance",
  "canvas.minimizedDock.restore": "Restore"
}
